export default __webpack_public_path__ + "static/media/icon-movie.6f5f1f4b.svg";